module.exports = __webpack_public_path__ + "static/media/screenMockBlue.9d445588.png";